<template>
  <v-container
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
    dashboard
  >
    <v-layout wrap>
      <v-flex
        md6
        xs12
      >
        <v-card style="margin-bottom:20px;">
          <v-flex>
            <v-card-title>{{ $t('wallets.stakingWallet') }}</v-card-title>
            <span>{{ $t('wallets.stakingWalletHint') }}</span>
            <v-text-field
              v-if="me.staking_wallet != null"
              :value="me.staking_wallet.wallet_address"
              name="trader-wallet"
              :disabled="true"
              @focus="$event.target.select()"
            />
          </v-flex>
          <v-flex
            d-flex
            justify-end
          >
            <v-btn
              text
              outlined
              @click="$router.push('/wallets/verify/1?a=change')"
            >
              {{ me.staking_wallet != null ? $t('wallets.changeWallet') : $t('wallets.addWallet') }}
            </v-btn>
          </v-flex>
        </v-card>
        <v-card>
          <v-flex>
            <v-card-title>{{ $t('wallets.payoutWallets') }}</v-card-title>
            <v-text-field
              v-model.trim="me.trader_wallet"
              name="trader-wallet"
              :placeholder="$t('wallets.traderWalletPlaceholder')"
              :label="$t('wallets.traderWallet')"
              :error-messages="traderWalletError"
              @input="$v.me.trader_wallet.$touch()"
              @blur="$v.me.trader_wallet.$touch()"
            >
              <template v-slot:append>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  {{ $t('wallets.traderWalletHint') }}
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              v-model.trim="me.aff_wallet"
              name="aff-wallet"
              :placeholder="$t('wallets.affWalletPlaceholder')"
              :label="$t('wallets.affWallet')"
              :error-messages="affWalletError"
              @input="$v.me.aff_wallet.$touch()"
              @blur="$v.me.aff_wallet.$touch()"
            >
              <template v-slot:append>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  {{ $t('wallets.affWalletHint') }}
                </v-tooltip>
              </template>
            </v-text-field>
          </v-flex>
          <v-flex
            d-flex
            justify-end
          >
            <v-btn
              text
              outlined
              :disabled="loading"
              :loading="loading"
              @click="Save"
            >
              {{ $t('globals.saveButton') }}
            </v-btn>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import UPDATE_USER_MUTATION from "@/graphql/mutations/UpdateUser.gql";
var WAValidator = require("wallet-address-validator");
import { validationMixin } from "vuelidate";

import IconWallet from "@/components/icons/IconWallet.vue";

const validate_wallet = value => {
  if (value == "" || value == null) return true;
  return WAValidator.validate(value, "BTC");
};

export default {
  name: "Profile",
  mixins: [validationMixin],
  data() {
    return {
      newIcon: IconWallet,
      loading: false
    };
  },
  validations() {
    return {
      me: this.rules
    };
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    rules() {
      var me = {
        trader_wallet: {
          validate_wallet
        },
        aff_wallet: {
          validate_wallet
        }
      };
      return me;
    },
    traderWalletError() {
      const errors = [];
      if (!this.$v.me.trader_wallet.$dirty) return errors;
      !this.$v.me.trader_wallet.validate_wallet &&
        errors.push(this.$t("wallets.walletNotValid"));
      return errors;
    },
    affWalletError() {
      const errors = [];
      if (!this.$v.me.aff_wallet.$dirty) return errors;
      !this.$v.me.aff_wallet.validate_wallet &&
        errors.push(this.$t("wallets.walletNotValid"));
      return errors;
    }
  },
  methods: {
    Save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        let form = {};

        if (this.me.trader_wallet != "" && this.me.trader_wallet != null)
          form.trader_wallet = this.me.trader_wallet;
        if (this.me.aff_wallet != "" && this.me.aff_wallet != null)
          form.aff_wallet = this.me.aff_wallet;

        this.$apollo
          .mutate({
            mutation: UPDATE_USER_MUTATION,
            variables: form
          })
          .then(data => {
            this.responseHandler(this.$t("globals.updatedSuccess"));
            this.loading = false;
          })
          .catch(error => {
            this.errorHandler(error);
            this.loading = false;
          });
      }
    }
  },
  apollo: {
    me: {
      query: require("@/graphql/queries/Me.gql")
    }
  }
};
</script>



<style lang="scss" >
@import "@/styles/material-dashboard/_colors.scss";

.dashboard {
  .v-card__title {
    margin-bottom: 15px;
  }
  .v-card__text {
    padding: 3px;
    .v-avatar {
      border-radius: 50% !important;
      background: #173eb7;
      margin-top: -2px;
      .v-icon {
        color: $grey-100;
      }
    }
    span {
      font-weight: 400;
      font-size: 20px;
      margin: 10px;
      color: $black;
    }
  }
}
</style>
